import { OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { UserRegistrationService } from '../../shared/service/user-registration.service';
import { CompanyService } from '../../shared/service/company.service';
import { ToastrService } from 'ngx-toastr';
import { SyncToStgService } from 'src/app/shared/service/sync-to-stg.service';
var RegistrationComponent = /** @class */ (function () {
    function RegistrationComponent(fb, userRegistrationService, companyService, toastrService, syncToStgService) {
        this.fb = fb;
        this.userRegistrationService = userRegistrationService;
        this.companyService = companyService;
        this.toastrService = toastrService;
        this.syncToStgService = syncToStgService;
        this.companies_stg2 = []; // STG2環境用
        this.freezeUser = new FormControl(-1);
        this.company_selected = '';
        this.userList = [];
        // setup form
        // one company can have multiple users(FormArray)
        this.newUserForm = this.fb.group({
            company_id: ['', Validators.required],
            company_stg_id: ['0', Validators.required],
            company_detail: this.fb.group({
                name: [''],
                company_code: [''],
                mail_domain: [''],
                representative_mail_account: ['']
            }),
            users: this.fb.array([this.NewUser()])
        });
    }
    Object.defineProperty(RegistrationComponent.prototype, "users", {
        get: function () {
            return this.newUserForm.get('users');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "company_id", {
        get: function () {
            return this.newUserForm.get('company_id');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "company_detail", {
        get: function () {
            return this.newUserForm.get('company_detail');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "company_stg_id", {
        get: function () {
            return this.newUserForm.get('company_stg_id');
        },
        enumerable: true,
        configurable: true
    });
    RegistrationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSTG = this.syncToStgService.needSync();
        this.needSync = this.syncToStgService.needSync();
        this.getCompanyList().then(function () {
            _this.loadUsers();
            _this.companyIdValueChangesSubscription = _this.company_id.valueChanges.subscribe(function (val) { return _this.companySelectChange(); });
        }).catch(function (err) {
            console.error('Error loading company list', err);
        });
    };
    RegistrationComponent.prototype.ngOnDestroy = function () {
        if (this.companyListSubscription) {
            this.companyListSubscription.unsubscribe();
        }
        if (this.companyStgListSubscription) {
            this.companyStgListSubscription.unsubscribe();
        }
        if (this.companyIdValueChangesSubscription) {
            this.companyIdValueChangesSubscription.unsubscribe();
        }
        if (this.userListSubscription) {
            this.userListSubscription.unsubscribe();
        }
        if (this.freezeUserSubscription) {
            this.freezeUserSubscription.unsubscribe();
        }
    };
    RegistrationComponent.prototype.NewUser = function () {
        return this.fb.group({
            name: ['', Validators.required],
            email: ['', Validators.required],
            user_code: ['', Validators.required],
            auth: [2, Validators.required],
            password: ['Abcd1234', Validators.required],
            password_confirm: ['Abcd1234', Validators.required],
            gross_margin_setting: ['5', Validators.required]
        });
    };
    RegistrationComponent.prototype.getCompanyList = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.companyListSubscription = _this.companyService.getCompanyList().subscribe({
                next: function (res) {
                    _this.companies = res.body;
                    _this.companies.unshift({ company_code: 'not exist', id: '-1' });
                    _this.company_id.setValue(_this.companies[0].id);
                    resolve();
                },
                error: function (err) {
                    _this.toastrService.warning("Can't get company list!");
                    console.warn("Can't get company list!");
                    console.warn(err);
                    reject(err);
                }
            });
            if (_this.isSTG && _this.needSync) {
                _this.companyStgListSubscription = _this.syncToStgService.getCompanyList().subscribe({
                    next: function (res) {
                        _this.companies_stg2 = res.body;
                        _this.companies_stg2.unshift({ company_code: 'not exist', id: '-1' });
                        _this.company_stg_id.setValue(_this.companies_stg2[0].id);
                        resolve();
                    },
                    error: function (err) {
                        _this.toastrService.warning("STG2_Can't get company list!");
                        console.warn("STG2_Can't get company list!");
                        console.warn(err);
                        reject(err);
                    }
                });
            }
        });
    };
    RegistrationComponent.prototype.addNewUser = function () {
        this.users.push(this.NewUser());
    };
    RegistrationComponent.prototype.deleteUser = function (num) {
        this.users.removeAt(num);
    };
    RegistrationComponent.prototype.companySelectChange = function () {
        var _this = this;
        var companySelected = this.companies.find(function (company) { return String(company.id) === _this.company_id.value; });
        if (companySelected) {
            var companyStg2Selected = this.companies_stg2.find(function (company_stg2) { return company_stg2.company_code === companySelected.company_code; });
            if (companyStg2Selected) {
                this.company_stg_id.setValue(companyStg2Selected.id);
            }
            else {
                this.company_stg_id.setValue('-1');
            }
        }
    };
    RegistrationComponent.prototype.onSubmit = function () {
        this.userRegistrationService.createNewUsers(this.newUserForm.value);
        if (this.isSTG && this.needSync) {
            this.userRegistrationService.createNewUsers(this.newUserForm.value, '_STG2');
        }
    };
    RegistrationComponent.prototype.loadUsers = function () {
        var _this = this;
        this.userListSubscription = this.userRegistrationService.getUserList().subscribe(function (res) {
            _this.userList = res.body;
        });
    };
    RegistrationComponent.prototype.freeze = function () {
        var _this = this;
        this.freezeUserSubscription = this.userRegistrationService
            .freezeUser(this.freezeUser.value)
            .subscribe(function (res) {
            _this.userList = res.body;
            _this.freezeUser.reset();
            _this.toastrService.success('freeze switch success');
        });
    };
    return RegistrationComponent;
}());
export { RegistrationComponent };
